import * as React from "react";

import Img from "../../smart/img/img";
import { massageImageUrl } from "common/components/portable-renderers";
import { AvatarOverlayViewStyle } from "./avatar-overlay-view-style";
import type { TextSize } from "generator/components/text-types";
import { isEmoji } from "common/Support";

interface AvatarViewProps {
    className?: string;
    text?: string;
    textSize: TextSize;
    image?: string;
    appID?: string;
}

export default class AvatarOverlayView extends React.PureComponent<AvatarViewProps> {
    public render(): React.ReactNode {
        const { className, text, textSize, image, appID } = this.props;

        if (text === undefined && image === undefined) return null;

        let imageStyle: React.CSSProperties | undefined = undefined;

        if (image && isEmoji(image)) {
            imageStyle = { marginRight: 8 };
        }

        return (
            <AvatarOverlayViewStyle className={className} data-test="app-avatar-wrap" textSize={textSize}>
                {image !== undefined && (
                    <Img
                        data-test="app-avatar-img"
                        style={imageStyle}
                        src={massageImageUrl(
                            image,
                            {
                                thumbnail: true,
                                width: 32,
                                height: 32,
                            },
                            appID
                        )}
                    />
                )}
                {text !== undefined && (
                    <div data-test="app-avatar-text" className="floating-overlay-text">
                        {text}
                    </div>
                )}
            </AvatarOverlayViewStyle>
        );
    }
}
